import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authFetchJson } from "./auth-fetch";
import { useAuthStore } from "./auth";

export type TenantNotificationSettings = {
  senderName?: string | null;
  replyToEmail?: string | null;
  emailAdminsOnNewBooking?: boolean;
  weeklyDigestEnabled?: boolean;
};

export const TENANT_NOTIFICATION_DEFAULTS: Required<TenantNotificationSettings> = {
  senderName: null,
  replyToEmail: null,
  emailAdminsOnNewBooking: false,
  weeklyDigestEnabled: false,
};

export function useTenantNotificationSettings() {
  const accessToken = useAuthStore((s) => s.accessToken);
  return useQuery({
    queryKey: ["tenants", "me", "notification-settings"],
    enabled: !!accessToken,
    queryFn: () =>
      authFetchJson<TenantNotificationSettings>(
        `/api/v1/tenants/me/notification-settings`,
      ),
  });
}

export function useUpdateTenantNotificationSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<TenantNotificationSettings>) =>
      authFetchJson<TenantNotificationSettings>(
        `/api/v1/tenants/me/notification-settings`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: () =>
      qc.invalidateQueries({
        queryKey: ["tenants", "me", "notification-settings"],
      }),
  });
}
